import { writable } from 'svelte/store';
import type { Writable } from 'svelte/store';
import type { Player } from './lib/models/player.type';
import type { MapData, MapNode } from './lib/models/map.type';
import { memory } from './lib/utils/memory';
import type { Technique } from './lib/models/techniques.type';
import type { Die } from './lib/models/die.type';
import { Screen } from './lib/models/screen.type';
// import { data } from 'vis-network';
memory.init();

export const version = '0.0.30';
// export const state = writable('menu');
export const screens = Screens();
export const stateNode: Writable<MapNode> = writable();

export const options = writable({
  tooltipsKeywords: memory.get('tooltipsKeywords') === false ? false : true,
  autoPlay: memory.get('autoPlay') || false,
  invincible: memory.get('invincible') || false,

  volumeEffects: memory.get('volumeEffects') || 50,
  volumeMusic: memory.get('volumeMusic') || 50,
});

export const playerTruth: Writable<Player> = writable();
export const activePlayer: Writable<Player> = writable();
export const inactivePlayer: Writable<Player> = writable();

export const networkMap = writable<any>();
export const map = writable<MapData>();

export const playerInstance = history({});
export const enemyInstance = history({});
export const dieHistory = history([]);
export const actionHistory: Array<string> = [];
export const techniqueHistory: Array<any> = [];
export let lockedDie: Array<Die> = [];
export const intervals = {
  particleInterval: null,
};
export let glossary = {
  open: writable(false),
  selected: writable('techniques'),
  searchTerm: writable(''),
  searchDie: writable<Array<any>>([]),
};

export function getStore(store: Writable<any>) {
  let $val;
  store.subscribe(($) => ($val = $))();
  return $val;
}

export const dragItem = writable<any>();

/**
 * The one die currently being peeked at, or null. A touch hold sets it and the
 * release clears it. Only one can be open at a time, which is the point: a
 * phone has no pointer to leave an element, so nothing else would ever close
 * the last one.
 *
 * Holds the die itself rather than its id -- a cloned die keeps the id of the
 * die it was cloned from, so matching on id would open two tips at once.
 */
export const peekedDie = writable<Die | null>(null);

function history(initialState: any) {
  const current = writable(initialState); // The only store really needed
  const history = [initialState];
  let index = 0;

  const refresh = () => {
    current.set(history[index]);
    // console.log(history.map(item => item.id), history[index].id);
  };

  const set = (newState: any) => {
    history[index] = newState;
    refresh();
  };

  const put = (newState: any) => {
    // clears the future items
    history.length = index + 1;

    // put() keeps what it is given, so callers hand it a copy: the board puts
    // clonePlayer() copies, which clone every modifier onto the new player, and
    // cloned dice.
    history.push(newState);
    index++;
    refresh();
    return history[index];
  };

  const clear = () => {
    history[0] = history[index];
    history.length = 1;
    index = 0;
    refresh();
  };

  const undo = () => {
    index = Math.max(0, index - 1);
    refresh();
  };

  return {
    set,
    put,
    history,
    subscribe: current.subscribe,
    undo: undo,
    redo: () => {
      index = Math.min(history.length - 1, index + 1);
      refresh();
    },
    clear: () => {
      clear();
    },
    count: () => {
      return index;
    },
  };
}

type ScreenEntry = {
  type: Screen;
  state: 'visible' | 'hidden' | 'loading' | 'unloading' | 'unloaded';
  data: any;
};

function Screens() {
  const current = writable<Array<ScreenEntry>>([
    {
      type: Screen.Menu,
      state: 'visible',
      data: {},
    },
  ]);

  const self = {
    subscribe: current.subscribe,
    push: (screen: Screen, data?: any) => {
      current.update((screens) => {
        screens.forEach((screen) => {
          if (screen.state == 'visible' || screen.state == 'loading') {
            screen.state = 'hidden';
          }
        });
        screens.push({
          type: screen,
          state: 'loading',
          data: data || {},
        });
        return screens;
      });
    },
    set: (screen: Screen, data?: any) => {
      current.update((screens) => {
        // pop
        let screeen = screens.findLast((screen) => screen.state == 'visible');
        if (screeen) {
          screeen.state = 'unloading';
          setTimeout(() => {
            screeen.state = 'unloaded';
          }, 1000);
        }

        // push
        screens.forEach((screen) => {
          if (screen.state == 'visible' || screen.state == 'loading') {
            screen.state = 'hidden';
          }
        });
        screens.push({
          type: screen,
          state: 'loading',
          data: data || {},
        });
        return screens;
      });
    },
    pop: () => {
      current.update((screens) => {
        let screen = screens.findLast((screen) => screen.state == 'visible');
        if (screen) {
          screen.state = 'unloading';
          setTimeout(() => {
            screen.state = 'unloaded';
          }, 1000);
        }
        return screens;
      });
    },
    removeUnloaded: () => {
      current.update((screens) => {
        screens = screens.filter((screen) => screen.state !== 'unloaded');
        return screens;
      });
    },
    clear: () => {
      current.set([
        {
          type: Screen.Menu,
          state: 'visible',
          data: {},
        },
      ]);
    },
  };
  return self;
}
